export const PHONE = "+91 89718 30609";
export const PHONE_TEL = "+918971830609";
export const WA_NUMBER = "918971830609";
export const PROP_PHONE = "+91 97417 55448";
export const PROP_PHONE_TEL = "+919741755448";
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_crispy-chicken-bg/artifacts/m3pks20a_images.jpeg";
export const ADDRESS = "KKFC, Opp Municipal Office, near SBI Bank, Bangarapet, Karnataka 563114";
export const MAP_EMBED = "https://www.google.com/maps?q=KKFC+Opp+Municipal+Office+near+SBI+Bank+Bangarapet+Karnataka+563114&output=embed";
export const HOURS = [
  { day: "Mon – Sat", time: "12:00 PM – 10:00 PM" },
  { day: "Sunday", time: "12:00 PM – 10:30 PM" },
];
export const WA_DEFAULT_MSG = "Hi KKFC Bangarpet! I would like to place an order for pre-order/home delivery.";
export const WA_LINK = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_DEFAULT_MSG)}`;

export const buildWaLink = (item) => {
  const msg = item
    ? `Hi KKFC Bangarpet! I would like to order for pre-order/home delivery: ${item}`
    : WA_DEFAULT_MSG;
  return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;
};

export const menuCategories = [
  {
    id: "fried-chicken",
    title: "Crunchy Fried Chicken",
    tag: "Signature · Halal",
    image: "https://customer-assets.emergentagent.com/job_crispy-chicken-bg/artifacts/vjh3d2en_IMG-20260506-WA0038.jpg",
    bg: "#FFF9E6",
    items: [
      { name: "Crunchy Leg Piece (1 pc)", price: 75, desc: "Juicy leg piece with a crunchy golden coating.", badge: "Bestseller" },
      { name: "Crunchy Thigh Piece (1 pc)", price: 85, desc: "Tender thigh meat with a double-crispy outside." },
      { name: "Crunchy Chest Piece (1 pc)", price: 85, desc: "Big, meaty chest piece — filling and satisfying." },
      { name: "Crunchy Leg Lollipop (1 pc)", price: 80, desc: "Easy-grip lollipop, full of flavour." },
      { name: "Crunchy Lollipops (3 pcs)", price: 95, desc: "Trio of crunchy lollipops — perfect for sharing." },
      { name: "Crunchy Hot Wings (4 pcs)", price: 95, desc: "Fiery hot wings dripping with signature spice blend." },
      { name: "Crunchy Spicy Wings (4 pcs)", price: 95, desc: "Extra-spicy wings for bold flavour lovers." },
      { name: "Lemon Crunchy Wings (5 pcs)", price: 125, desc: "Tangy lemon-zest wings, light and crispy." },
      { name: "Crunchy Pop Corns", price: 99, desc: "Bite-size crispy chicken pops — highly addictive." },
      { name: "Crunchy Chicken — Half Bucket (4 pcs)", price: 320, desc: "Family-share half bucket with 4 mixed pieces.", badge: "Family" },
      { name: "Crunchy Chicken — Full Bucket (8 pcs)", price: 590, desc: "Full party bucket with 8 juicy pieces.", badge: "Party" },
    ],
  },
  {
    id: "burgers",
    title: "Chicken Burgers",
    tag: "Hand-held",
    image: "https://customer-assets.emergentagent.com/job_crispy-chicken-bg/artifacts/t7v3u3dk_IMG-20260506-WA0040.jpg",
    bg: "#FFFFFF",
    items: [
      { name: "Cheesy Chicken Burger", price: 90, desc: "Crispy patty with melted cheese in a soft bun." },
      { name: "Chicken Spicy Burger", price: 85, desc: "Tangy and spicy patty for spice lovers.", badge: "Spicy" },
      { name: "Double Chicken Burger", price: 120, desc: "Two patties, double the protein, double the flavour." },
      { name: "Double Chicken Spicy Burger", price: 149, desc: "Double patty with an extra spice kick." },
      { name: "Double Cheesy Chicken Burger", price: 149, desc: "Double patty with double cheese — full overload." },
      { name: "Zinger Burger", price: 110, desc: "Signature zinger — crunchy, spicy and perfect.", badge: "Bestseller" },
      { name: "Double Zinger Burger", price: 149, desc: "Two zinger patties stacked tall." },
    ],
  },
  {
    id: "pizzas",
    title: "Chicken Pizzas",
    tag: "Oven-fresh",
    image: "https://customer-assets.emergentagent.com/job_crispy-chicken-bg/artifacts/vutrk9ho_IMG-20260506-WA0042.jpg",
    bg: "#FFF9E6",
    items: [
      { name: "Chicken Grilled BBQ Pizza", price: 220, desc: "Smoky BBQ chicken, melted cheese and a char-grilled crust." },
      { name: "Special Ranch Pizza", price: 240, desc: "Creamy ranch with tender chicken — a KKFC special." },
      { name: "Chicken Sweet Corn Pizza", price: 270, desc: "Sweet corn and chicken combo, cheesy and comforting." },
      { name: "Chicken Pineapple Sweet Corn Pizza", price: 270, desc: "Sweet, savoury and loaded — a full party pizza." },
      { name: "Chicken Golden Delight", price: 289, desc: "House signature with a golden top and grill stripes.", badge: "Signature" },
    ],
  },
  {
    id: "starters",
    title: "Chicken Non-Veg Starters",
    tag: "Side Stars",
    image: "https://customer-assets.emergentagent.com/job_crispy-chicken-bg/artifacts/nbcweuhp_IMG-20260506-WA0039.jpg",
    bg: "#FFFFFF",
    items: [
      { name: "Chicken Nuggets", price: 85, desc: "Bite-sized golden nuggets — a kids' favourite." },
      { name: "Chicken Poppers", price: 90, desc: "Crispy poppers, easy to share and hard to stop." },
      { name: "Chicken Sticks", price: 85, desc: "Crunchy chicken finger sticks, hot and fresh." },
      { name: "Chicken Cheese Balls", price: 99, desc: "Cheese-stuffed crispy balls with a molten centre.", badge: "Cheesy" },
    ],
  },
  {
    id: "noodles-momos",
    title: "Noodles & Momos",
    tag: "Indo-Chinese",
    image: "https://customer-assets.emergentagent.com/job_crispy-chicken-bg/artifacts/gw4livap_IMG-20260506-WA0044.jpg",
    bg: "#FFF9E6",
    items: [
      { name: "Crunchy Chicken Noodles", price: 125, desc: "Wok-tossed noodles topped with crunchy chicken." },
      { name: "Egg Noodles", price: 110, desc: "Classic egg noodles, hot and spicy Indo-Chinese style." },
      { name: "Chicken Momos", price: 110, desc: "Steamed chicken momos served with fiery red chutney." },
    ],
  },
  {
    id: "veg-pizzas",
    title: "Veg Pizzas",
    tag: "Vegetarian · Oven-fresh",
    image: "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=800&q=80",
    bg: "#E8F5E9",
    isVeg: true,
    items: [
      { name: "Veg Paneer Fusion", price: 220, desc: "Paneer cubes with mixed veggies and cheese.", badge: "Popular" },
      { name: "Golden Delight Pizza", price: 230, desc: "Golden corn and veggie medley with cheese." },
      { name: "Veg Butter Cheese Pizza", price: 230, desc: "Buttery base with loaded cheese and vegetables." },
      { name: "Veg Butter Corn Pizza", price: 230, desc: "Sweet corn with butter and melted cheese." },
    ],
  },
  {
    id: "veg-starters",
    title: "Veg Starters",
    tag: "Vegetarian · Crispy",
    image: "https://images.unsplash.com/photo-1630384060421-cb20d0e0649d?w=800&q=80",
    bg: "#FFFFFF",
    isVeg: true,
    items: [
      { name: "Potato Poppers", price: 90, desc: "Crispy paneer bites with spicy coating.", badge: "Bestseller" },
      { name: "Cheese Sticks", price: 99, desc: "Gooey cheese sticks with crunchy exterior." },
      { name: "Veg Cheese Balls", price: 99, desc: "Vegetable and cheese balls, crispy and delicious." },
      { name: "French Fries", price: 85, desc: "Classic golden fries, crispy and salted." },
      { name: "Peri Peri French Fries", price: 85, desc: "Spicy peri peri seasoned fries." },
      { name: "Cheese French Fries", price: 120, desc: "Loaded fries with melted cheese on top." },
      { name: "Cheese Peri Peri Fries", price: 120, desc: "Ultimate combo of cheese and peri peri spice." },
    ],
  },
  {
    id: "veg-burgers",
    title: "Veg Burgers",
    tag: "Vegetarian · Hand-held",
    image: "https://images.unsplash.com/photo-1520072959219-c595dc870360?w=800&q=80",
    bg: "#E8F5E9",
    isVeg: true,
    items: [
      { name: "Veg Burger", price: 85, desc: "Classic veg patty with fresh veggies in a soft bun." },
      { name: "Paneer Burger", price: 99, desc: "Grilled paneer patty with tangy sauce.", badge: "Popular" },
    ],
  },
  {
    id: "veg-noodles-momos",
    title: "Veg Noodles & Momos",
    tag: "Vegetarian · Indo-Chinese",
    image: "https://images.unsplash.com/photo-1612929633738-8fe44f7ec841?w=800&q=80",
    bg: "#FFFFFF",
    isVeg: true,
    items: [
      { name: "Veg Noodles", price: 95, desc: "Stir-fried noodles with fresh vegetables." },
      { name: "Veg paneer Noodles", price: 99, desc: "Indo-Chinese style hakka noodles with veggies." },
      { name: "Veg Momos", price: 85, desc: "Steamed vegetable momos with spicy chutney." },
      { name: "Paneer Momos", price: 95, desc: "Paneer-filled momos, soft and flavorful." },
      { name: "Cheese Corn Momos", price: 99, desc: "Cheese and corn stuffed momos — a fusion delight." },
    ],
  },
  {
    id: "beverages",
    title: "Beverages & Ice Creams",
    tag: "Refreshments",
    image: "https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=800&q=80",
    bg: "#E3F2FD",
    isVeg: true,
    items: [
      { name: "Cool Drinks", price: 30, desc: "Chilled soft drinks to refresh." },
      { name: "Goli Soda", price: 30, desc: "Traditional Indian carbonated drink." },
      { name: "Arun Ice Creams", price: 50, desc: "Creamy ice cream in various flavors." },
      { name: "Scoops", price: 40, desc: "Single scoop ice cream — perfect treat." },
    ],
  },
];

export const reviews = [
  {
    name: "Arjun K.",
    role: "Student, Bangarpet",
    rating: 5,
    text: "KKFC's crispy chicken is seriously addictive. I drop by every week after college — tasty and student-friendly pricing!",
  },
  {
    name: "Priya & Family",
    role: "Family Diner",
    rating: 4,
    text: "Visited with the whole family — the kids loved the nuggets and burgers. Fast service and a clean place. Highly recommended.",
  },
  {
    name: "Rohit M.",
    role: "Local Foodie",
    rating: 4,
    text: "The spicy wings are unreal. Quick takeaway, hot packaging and excellent flavour. The best fried chicken spot in Bangarpet.",
  },
];

export const galleryImages = [
  {
    src: "https://customer-assets.emergentagent.com/job_crispy-chicken-bg/artifacts/3y7go6t6_2025-02-03.jpg",
    alt: "KKFC Bangarpet dining hall",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_crispy-chicken-bg/artifacts/iyf0tb4i_unnamed%20%281%29.jpg",
    alt: "Signature chicken pizza at KKFC Bangarpet",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_crispy-chicken-bg/artifacts/mb3zud3h_2024-08-15.jpg",
    alt: "KKFC loaded chicken pizza",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_crispy-chicken-bg/artifacts/d65wuwmv_2025-03-27.jpg",
    alt: "KKFC Bangarpet counter and seating",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_crispy-chicken-bg/artifacts/wcxir113_2025-03-27%20%281%29.jpg",
    alt: "Cozy interior with chilled drinks",
  },
  {
    src: "/assets/WhatsApp Image 2026-05-07 at 7.10.03 PM (8).jpeg",
    alt: "KKFC Bangarpet restaurant interior with customers",
  },
];
